import { cn } from "@omni/utils/styles";

import { ReviewAuthorModel } from "@/types/service/reviews/reviewAuthor.model";

type ReviewerProps = {
    range: number;
    reviewer: ReviewAuthorModel;
    onClick: () => void;
};

export const Reviewer = ({ reviewer, onClick }: ReviewerProps) => {
    return (
        <div
            className={cn(
                "tw:font-bold tw:cursor-pointer",
                "tw:hover:underline"
            )}
            onClick={onClick}
        >
            <p>{reviewer.name}</p>
        </div>
    );
};
